import { Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from '@/src/application/hooks/util/useFeatureFlag';
import { MY_PLAN_PATHS } from '@/src/modules/MyPlanModule/constants';
import {
  BillingAndConsumption,
  BillingAndConsumptionV2,
  ManagePlan,
} from '@/src/modules/MyPlanModule/screens';

export const MyPlanModuleRouter = () => {
  //TODO: Fix this to prevents flaky bad redirects
  // const navigate = useNavigate();
  // const { userData } = useStateUserContext();
  // const hiddenUsageAndBilling = useFeatureFlag('hiddenUsageAndBilling');
  // const hasRoleAdmin =
  //   ROLES.SUPER_ADMIN_ADMIN === userData.role || ROLES.AGENCY_ADMIN === userData.role;

  // useEffect(() => {
  //   if (!hasRoleAdmin && hiddenUsageAndBilling) {
  //     navigate('/v2');
  //   }
  // }, [hasRoleAdmin, hiddenUsageAndBilling, navigate]);
  const isInvoiceWhatsAppEnabled = useFeatureFlag('enableInvoiceWhatsApp');

  return (
    <Routes>
      <Route
        element={isInvoiceWhatsAppEnabled ? <BillingAndConsumptionV2 /> : <BillingAndConsumption />}
        path={MY_PLAN_PATHS.BILLING_AND_CONSUMPTION_PATH}
      />
      <Route element={<ManagePlan />} path={MY_PLAN_PATHS.MANAGE_PLAN} />
    </Routes>
  );
};
